import type { OnboardingInterface } from "@qendo/onboarded";
import Data from "~/util/data";

export class Onboarded extends Data implements OnboardingInterface {
    public constructor(
        public welcome_back: boolean = false,
        public cycle: boolean = true,
        public care_team: boolean = false,
        public health_profile: boolean = false,
    ) {
        super();
    }
}
